
import React, { Fragment } from "react";
import request from '../../../api';
import { Button, Dialog, DialogContent, DialogContentText, TextField, DialogActions, DialogTitle, Select, MenuItem, InputLabel } from '@material-ui/core'
import { Teacher } from "../../../interfaces/examiner/Teacher";
import { loadStripe } from "@stripe/stripe-js";
import { Payment } from "../../../interfaces/teacher/Payment,";

interface Props {
    onClose:()=>void
    onDelete:(teacher:Teacher)=>void
    teacher:Teacher
}

interface State {
}

export default class ExamDeleteDialog extends React.Component<Props, State> {

    constructor(props:Props) {

        super(props)

        this.state = {
        }
    }

    render() {
        return (
            <div>
            <Dialog open={true} onClose={this.props.onClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Delete Teacher</DialogTitle>
                    <DialogContent>
                        <p>Are you sure you wish to delete {this.props.teacher.name} ({this.props.teacher.schoolCode})?</p>             
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onDelete} color="secondary">
                            Yes
                        </Button>
                        <Button onClick={this.onClose} color="secondary">
                            No
                        </Button>
                    </DialogActions>                    
            </Dialog>
            </div>
        );
    }

    onDelete = () => {
        this.props.onDelete(this.props.teacher)
    }

    onClose = () => {
        this.props.onClose()
    }

}